import React from "react";
import "../styles/moretrust.css";

function MoreTrust() {
  return (
    <div className="moretrust-wrapper">
      <div className="moretrust-container">
        <div className="moretrust-row">
          <img src="/hit.png" alt="HITRUST Badge" className="moretrust-badge" />
           <img src="/pci.png" alt="HITRUST Badge" className="moretrust-badge" />
           <img src="/soc21.png" alt="HITRUST Badge" className="moretrust-badge" />
           <img src="/soc22.png" alt="HITRUST Badge" className="moretrust-badge" />
           <img src="/hit.png" alt="HITRUST Badge" className="moretrust-badge" />
        </div>
      </div>
    </div>
  );
}

export default MoreTrust;
